import React, { useLayoutEffect, useMemo } from 'react';
import Header from "../../components/header/Header";
import StartSection from "./sections/startSection/StartSection";
import AboutUsNumbersSection from "./sections/aboutUsNumbersSection/AboutUsNumbersSection";
import GlobalCommunitySection from "./sections/globalCommunitySection/GlobalCommunitySection";
import Web3EasySection from "./sections/web3EasySection/Web3EasySection";
import TeamSection from "./sections/teamSection/TeamSection";
import FooterSection from "../../components/footer/FooterSection";
import BlogSection from "./sections/blogSection/BlogSection";
import NfdMissionSection from './sections/nfdMissionSection/NfdMissionSection';
import DiscoverProductsSection from "./sections/discoverProductsSection/DiscoverProductsSection";

const Main = () => {

	return (
		<div className={`mainPage`}>
			<Header mode={'dark'} />
			<div className={"mainPage__bg"}>
				<div className={"mainPage__bg_1"} style={{mixBlendMode: 'difference'}}></div>
			</div>
			<StartSection />
			<DiscoverProductsSection />
			<NfdMissionSection />
			<AboutUsNumbersSection />
			<GlobalCommunitySection />
			<TeamSection isAboutUs={false}/>
			<Web3EasySection />
			<BlogSection />
			<FooterSection />
		</div>
	);
};

export default Main;